import React from 'react';
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid';
import { classNames } from '../helpers/functions';
import { createPortal } from 'react-dom';

export const EllipsisDropdownItem = ({
	onClick,
	danger,
	children,
	className,
}) => {
	return (
		<Menu.Item>
			{({ active }) => (
				<div
					onClick={() => (typeof onClick === 'function' ? onClick() : null)}
					className={classNames(
						active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
						'block px-4 py-2 text-sm cursor-pointer',
						danger ? 'text-red-700 hover:bg-red-50' : '',
						className
					)}
				>
					{children}
				</div>
			)}
		</Menu.Item>
	);
};

export default function EllipsisDropdown({
	children,
	EllipsisButton,
	disappearing,
}) {
	return (
		<Menu
			as="div"
			className={classNames(
				'relative inline-block text-left',
				disappearing ? 'invisible group-hover/item:visible ' : ''
			)}
		>
			<div>
				{EllipsisButton || (
					<Menu.Button className="flex items-center rounded-full text-gray-400 hover:text-gray-600">
						<span className="sr-only">Open options</span>
						<EllipsisVerticalIcon className="h-6 w-6" aria-hidden="true" />
					</Menu.Button>
				)}
			</div>

			<Transition
				as={Fragment}
				enter="transition ease-out duration-100"
				enterFrom="transform opacity-0 scale-95"
				enterTo="transform opacity-100 scale-100"
				leave="transition ease-in duration-75"
				leaveFrom="transform opacity-100 scale-100"
				leaveTo="transform opacity-0 scale-95"
			>
				<Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
					<div className="py-1">{children}</div>
				</Menu.Items>
			</Transition>
		</Menu>
	);
}
